import { type Row } from '../context.js';
import { ORB_LAYERS } from './orb-cast.js';

/** The cast route guard also covers modal/weapon/ritual callers that skip the ability adapter. */
export function orbLegacyRouteReason(ability: Row | null, value: (row: Row, key: string) => unknown, reason: string): string | null {
  return ability && [...ORB_LAYERS, 'channel_orb_each_turn'].some(key => value(ability, key) != null)
    ? 'orb_queue:legacy-route-retired:' + reason : null;
}
